import { useAppSelector } from "../../util/hooks";
import GeralPage from "./pages/geral";
import VisualizacaoPage from "./pages/visualizacao";

const pages: any = {
  geral: GeralPage,
  visualizacao: VisualizacaoPage,
};

const AuditoriaContaFinanceiraPageController = () => {
  //estados globais
  const auditoriaContaFinanceiraState = useAppSelector((state) => state.auditoriaContaFinanceira);

  const Page = pages[auditoriaContaFinanceiraState.page];

  return <Page key={auditoriaContaFinanceiraState.page} />;
};

export default AuditoriaContaFinanceiraPageController;
